module.exports = __webpack_public_path__ + "img/geofisica_16-9_1440.e75f79a0.jpg";